import FetchClient from 'ha/helpers/FetchClient';
import createMakeCall from 'ha/services/apiV2/createMakeCall';

import {
  addAnonymousPaymentRequest,
  addConversationPaymentRequest,
  getPaymentRequests,
  getPaymentRequestByHandle,
  payPaymentRequest,
  payPaymentRequestV2,
  payPaymentRequestV2Confirm,
  cancelPaymentRequest,
  submitIdealSource,
  checkIdealStatus,
} from './paymentRequests';

export {
  PaymentRequest,
  PayReqCommonParams,
  PayReqConversationParams,
  PayReqWithConversationParams,
  CancelPaymentRequest,
  PaymentRequestsResponse,
  SubmitIdealSource,
  CheckIdealStatus,
} from './paymentRequests';

const createOsiris = (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    addAnonymousPaymentRequest: addAnonymousPaymentRequest(makeCall),
    addConversationPaymentRequest: addConversationPaymentRequest(makeCall),
    getPaymentRequests: getPaymentRequests(makeCall),
    getPaymentRequestByHandle: getPaymentRequestByHandle(makeCall),
    payPaymentRequest: payPaymentRequest(makeCall),
    payPaymentRequestV2: payPaymentRequestV2(makeCall),
    payPaymentRequestV2Confirm: payPaymentRequestV2Confirm(makeCall),
    cancelPaymentRequest: cancelPaymentRequest(makeCall),
    submitIdealSource: submitIdealSource(makeCall),
    checkIdealStatus: checkIdealStatus(makeCall),
  };
};

export default createOsiris;
